import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { ColorAttributeInputControl } from './ColorAttributeInputControl';
import { ColorAttributeOptions } from '@gift/attributes-color-core/ColorAttributeOptions';
import { ColorAttributeInput } from '@gift/attributes-color-core/ColorAttributeInput';

export const colorAttributeWebsitePlugin: WebsitePlugin.Variable<ColorAttributeOptions, ColorAttributeInput> = {
    pluginId: 'color-attribute',
    InputControl: ColorAttributeInputControl,
    toFfCanvas: () => []
};